import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type documentsDataType = {
  endpoint: string;
  errorCallback?: Function;
  resultKey?: string;
  params?: object;
};

export default ({ endpoint, errorCallback, resultKey, params = {} }: documentsDataType) =>
  requestAsync({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    url: endpoints[`${endpoint}Url`](params),
    transform: (response) => ({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: response,
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    queryKey: endpoints[`${endpoint}Url`](params),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
